 
 export  var api_endpoint = "https://api.thailandtourismdirectory.go.th/api/v2"

// export var img_endpoint = "https://www.drjo.dodeep.work/assets/images"